export default __webpack_public_path__ + "static/media/online.31bab0fa.svg";